var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppTableControl',{attrs:{"no-filter":"","no-export":""},on:{"query-debounced":_vm.searchQuery}})
}
var staticRenderFns = []

export { render, staticRenderFns }